import { render, staticRenderFns } from "./CurriculumSection.vue?vue&type=template&id=bfa28bf6&"
import script from "./CurriculumSection.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSection.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports